import { createAsyncThunk } from '@reduxjs/toolkit';
import * as registerService from './register-api';
import { IRegisterUser } from '../../../core/utils/interfaces/register-interface';

export const checkIfUserIsRegistered = createAsyncThunk(
    'register/checkIfUserIsRegistered',
    async (email: string, { rejectWithValue }) => {
        try {
            const response = await registerService.checkIfUserIsRegistered(
                email
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const registerUser = createAsyncThunk(
    'register/registerUser',
    async ({ email, password }: IRegisterUser, { rejectWithValue }) => {
        try {
            const response = await registerService.registerUser(
                email,
                password
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);
